enum DebitCreditCode {
    debit = 'DBIT',
    credit = 'CRDT',
}
export default DebitCreditCode